/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc
 */
import * as References from './AccessRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc#loginVerify
 */
export const LOGIN_VERIFY_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_AccessRpc_loginVerify';
export const LOGIN_VERIFY_QUERY: RegisteredQuery<
  'result',
  References.LoginVerifyRequestType,
  References.LoginVerifyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LOGIN_VERIFY_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
  ],
  fetcher(
    request: References.LoginVerifyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.LoginVerifyResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.loginVerifyRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
